import { Box, useDisclosure } from "@chakra-ui/react"
import { AugmentationToolbarProps } from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import AugmentationToolbarPopover from "@pathwright/ux/src/components/augmentation/AugmentationToolbarPopover"
import UserAvatar from "@pathwright/ux/src/components/avatar/UserAvatar"
import { Indicator } from "@pathwright/ux/src/components/button/IconButton"
import React from "react"
import { useNotificationsState } from "../../notifications/state/notification-state"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"

const HomeAugmentationPopover = React.forwardRef<
  HTMLDivElement,
  AugmentationToolbarProps
>(({ toolbar }, ref) => {
  const { me } = usePathwrightContext()
  const { unreadCount } = useNotificationsState()
  const disclosure = useDisclosure()

  return me ? (
    // Wrapping with top-level box for ref to work properly (with AugmentationLayout).
    <Box ref={ref} pos="fixed" top="1rem" right="1rem" zIndex="overlay">
      <AugmentationToolbarPopover toolbar={toolbar} disclosure={disclosure}>
        <Box>
          <UserAvatar user={me} size="md" />
          {!!unreadCount && !disclosure.isOpen && <Indicator />}
        </Box>
      </AugmentationToolbarPopover>
    </Box>
  ) : null
})

export default HomeAugmentationPopover
